import React from "react";
import Popup from "reactjs-popup";
import styled from "styled-components";
import {useHistory, useParams, useLocation} from "react-router-dom";

const MenuPopup = styled(Popup)`
  .popup-content, &-content {
    min-width: 500px;
    max-height: 90%;
    display: block;
    overflow: scroll;
  }
  @media( max-width: 1000px){
    .popup-content,
    &-content {
    display: block;
    overflow: scroll;
    min-width: 80%;
  }
  }
`;

const Menu = styled.img`
  width: 100%;
`;

function Modal(props) {
  const history = useHistory()
  const location = useLocation()
  const menu = useParams().menuName

  console.log(location)
  function onClose(e){
    e.stopPropagation();
    history.push("/");
  }

  return (
    <MenuPopup
      onClose={onClose}
      open={true}
      modal
      closeOnDocumentClick
    >
      <Menu src={`${location.state.menu}`} />
    </MenuPopup>
  );
}

export default Modal;
